import {cerrarSesion} from '../utilities/Seguridad'
import axios from 'axios'
import moment from 'moment';

const qs = require('qs');
const FormData = require('form-data');

export async function getDataFormulario(token,id) {

    let config = {
        method: 'get',
        url: `${process.env.REACT_APP_URL}/formulario/${id}`,
        headers: { 
        'Authorization': `Bearer ${token}`
        }
        
    };
    
    const response =  await axios(config)
    .then((response) => {
        if(response.data.error===1) cerrarSesion(response.data);
        return response.data;
    })
    .catch((error) => {
        console.log(error);
        return null;
    });
    return response;
}

export async function getRespuestas(token,idpieformulario,dataObject) {

    let dataJson = JSON.stringify(Object.values(dataObject));
 
    let data = new FormData();
    data.append('data', dataJson);
    data.append('idpieformulario', idpieformulario);

    let config = {
        method: 'post',
        url: `${process.env.REACT_APP_URL}/formulario/respuestas`,
        headers: { 
        'Authorization': `Bearer ${token}`,
        //...data.getHeaders()
        },
        data : data
    };
    
    const response =  await axios(config)
    .then((response) => {
        if(response.data.error===1) cerrarSesion(response.data);
        if (response.data.error == 0) {
             response.data.resultado = dataObject;
             return response.data;
        }else{
            return response.data;
        }
        
    })
    .catch((error) => {
        console.log(error);
        return null;
    });
    return response;
}

export async function getDataRevTemplante(token,id) {
    
    let config = {
        method: 'get',
        url: `${process.env.REACT_APP_URL}/formulario/descarga/${id}`,
        headers: { 
        'Authorization': `Bearer ${token}`
        }   
    };
    const response =  await axios(config)
    .then((response) => {
        if(response.data.error===1) cerrarSesion(response.data);
        return response.data;
    })
    .catch((error) => {
        console.log(error);
        return null;
    });
    return response;
}


